export default __webpack_public_path__ + "static/facebook-edcf9779c3cbcd29b8f4a2bb16256a59.png";